export default __webpack_public_path__ + "311adc0c7a6546e4b1b6f7328e2da599.svg";